import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const MobileMockUp = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "mobile-mockup.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  if (!data?.placeholderImage?.childImageSharp?.fluid) {
    return null
  }

  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      className="w-99 h-99 md:w-100 md:h-100"
    />
  )
}

export default MobileMockUp
